<template>
    <div id="page-contact">
        <h3 class="page-title">Get In Touch</h3>
        <p>
            If you'd like to get in touch with me, send me a message on
            <a href='https://www.linkedin.com/in/chriskulbacki' target='_blank'>LinkedIn</a>
            or fill the form below.
        </p>

        <form id="contact-form">
            <div class="input-group" :class="{ error: formErrors['name'] && !name }">
                <label class="width-15">Your name:</label>
                <div>
                    <input type="text" v-model="name">
                    <div class="error-message">Type your name</div>
                </div>
            </div>
            <div class="input-group" :class="{ error: formErrors['email'] && !email }">
                <label class="width-15">Your email:</label>
                <div>
                    <input type="email" v-model="email">
                    <div class="error-message">Type a valid email address</div>
                </div>
            </div>
            <div class="input-group" :class="{ error: formErrors['message'] && !message }">
                <label class="width-15">Your message:</label>
                <div>
                    <textarea id="input-message" v-model="message"></textarea>
                    <div class="error-message">Type your message</div>
                </div>
            </div>

            <div class="input-group captcha" :class="{error:formErrors['captcha']}">
                <label class="width-15"></label>
                <div>
                    <div id='captcha-container'>
                        <div class="checkbox-container">
                            <div class="checkbox" @click="handleCheckboxClick()"></div>
                            <div class="checkmark"></div>
                            <div class="text">I'm not a robot</div>
                        </div>

                        <div class="logo-container">
                            <img src="https://www.gstatic.com/recaptcha/api2/logo_48.png" alt="" @click="setSolved(!solved)"/>
                            <div>reCAPTCHA</div>
                            <div>
                                <a href="https://www.google.com/intl/en/policies/privacy/">Privacy</a>
                                <span> - </span>
                                <a href="https://www.google.com/intl/en/policies/terms/">Terms</a>
                            </div>
                        </div>

                        <div class="challenge" :class="{visible: visible}">
                            <div class="bubble-arrow bubble-arrow-1"></div>
                            <div class="bubble-arrow bubble-arrow-2"></div>
                            <div class="header">
                                <div>Select all squares with</div>
                                <strong id="challenge-title">{{ tests[currentTest].text }}</strong>
                            </div>
                            <div class="squares">
                                <table>
                                    <tbody>
                                    <tr>
                                        <td><div class="img-1" :class="{ selected: selected[1] }" @click="select(1)"><div>
                                            <img style="top:0;left:0" :src="tests[currentTest].image" /></div></div></td>
                                        <td><div class="img-2" :class="{ selected: selected[2] }" @click="select(2)"><div>
                                            <img style="top:0;left:-126px" :src="tests[currentTest].image" /></div></div></td>
                                        <td><div class="img-3" :class="{ selected: selected[3] }" @click="select(3)"><div>
                                            <img style="top:0;left:-252px" :src="tests[currentTest].image" /></div></div></td>
                                    </tr>
                                    <tr>
                                        <td><div class="img-4" :class="{ selected: selected[4] }" @click="select(4)"><div>
                                            <img style="top:-126px;left:0" :src="tests[currentTest].image" /></div></div></td>
                                        <td><div class="img-5" :class="{ selected: selected[5] }" @click="select(5)"><div>
                                            <img style="top:-126px;left:-126px" :src="tests[currentTest].image" /></div></div></td>
                                        <td><div class="img-6" :class="{ selected: selected[6] }" @click="select(6)"><div>
                                            <img style="top:-126px;left:-252px" :src="tests[currentTest].image" /></div></div></td>
                                    </tr>
                                    <tr>
                                        <td><div class="img-7" :class="{ selected: selected[7] }" @click="select(7)"><div>
                                            <img style="top:-252px;left:0" :src="tests[currentTest].image" /></div></div></td>
                                        <td><div class="img-8" :class="{ selected: selected[8] }" @click="select(8)"><div>
                                            <img style="top:-252px;left:-126px" :src="tests[currentTest].image" /></div></div></td>
                                        <td><div class="img-9" :class="{ selected: selected[9] }" @click="select(9)"><div>
                                            <img style="top:-252px;left:-252px" :src="tests[currentTest].image" /></div></div></td>
                                    </tr>
                                    </tbody>
                                </table>
                                <div class="error-message" :class="{ visible: error }">{{ error }}</div>
                            </div>
                            <div class="footer">
                                <div class="icons">
                                <span>
                                    <img src="https://www.gstatic.com/recaptcha/api2/audio_2x.png" alt="" @click="handleAudioClick()" />
                                </span>
                                    <span>
                                    <img src="https://www.gstatic.com/recaptcha/api2/info_2x.png" alt="" @click="helpVisible = !helpVisible" />
                                </span>
                                </div>
                                <button type="button" @click="handleButtonClick()">NEXT</button>
                            </div>
                            <div class="help" v-if="helpVisible">
                                Tap on any tiles you see with the object described in the text. If new images appear with the same object, tap those as well. When there are none left, click Verify.
                            </div>
                        </div>
                    </div>
                    <div class="error-message">Prove you're not a robot.</div>
                </div>
            </div>

            <div class="input-group">
                <label class="width-15"></label>
                <div>
                    <button type="submit" class="primary" @click.prevent="sendMessage()">Send Message</button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                selected: {1: false, 2: false, 3: false, 4: false, 5: false, 6: false, 7: false, 8: false, 9: false},
                visible: false,
                error: false,
                currentTest: 0,
                tries: 0,
                helpVisible: false,

                tests: [
                    { text: "hidden snipers", image: "/images/redcaptcha/image-1.jpg" },
                    { text: "female zebra", image: "/images/redcaptcha/image-4.jpg" },
                    { text: "goddess Njorun", image: "/images/redcaptcha/image-3.jpg" },
                    { text: "Banford Award laureates", image: "/images/redcaptcha/image-5.jpg" },
                    { text: "Kāber-Kūh glyphs", image: "/images/redcaptcha/image-6.jpg" },
                    { text: "houses located in Europe", image: "/images/redcaptcha/image-2.jpg" },
                ],

                formErrors: {name: false, email: false, message: false, captcha: false},
                name: "",
                email: "",
                message: "",
            }
        },

        mounted() {
        },

        methods: {
            select(id) {
                this.selected[id] = !this.selected[id];
            },

            handleCheckboxClick() {
                if (!this.visible) {
                    this.tries = 0;
                    this.currentTest = -1;
                    this.error = false;
                    this.visible = true;
                    this.nextTest();
                } else {
                    this.visible = false;
                }
            },

            handleAudioClick() {
                this.setError("Audio not available at this time.");
            },

            handleButtonClick() {
                if (!this.hasSelected()) {
                    this.setError("Select all the matching squares.");
                    return;
                }

                this.tries = this.tries + 1;
                for (let key in this.selected) {
                    this.selected[key] = false;
                }
                // $(".squares td>div").removeClass("selected");

                if (this.tries > 4) {
                    this.nextTest();
                } else {
                    this.setError("Please try again");
                }
            },

            nextTest() {
                if (this.currentTest == this.tests.length - 1) {
                    this.currentTest = 0;
                } else {
                    this.currentTest++;
                }

                this.setError(false);
                this.tries = 0;
            },

            setError(error) {
                this.error = error;
            },

            hasSelected() {
                let count = 0;

                for (let key in this.selected) {
                    this.selected[key] && count++;
                }

                return count >= 3;
            },

            sendMessage() {
                this.formErrors['name'] = !this.name;
                this.formErrors['email'] = !this.email;
                this.formErrors['message'] = !this.message;
                this.formErrors['captcha'] = true;
            },
        }
    }
</script>

<style lang="scss">
    #page-contact {
        #captcha-container {
            position: relative;
            width: 304px;
            height: 78px;
            border: 1px solid #525252;
            background: #222222;
            font-family: Roboto, helvetica, arial, "sans-serif";

            .expired-text {
                display: none;
                color: #ff0000;
                font-size: 12px;
                line-height: 1rem;
                width: 240px;
                padding-left: 1px;
            }

            .checkbox-container {
                position: absolute;
                top: 0;
                left: 0;
                right: 80px;
                bottom: 0;
            }

            .checkbox {
                position: absolute;
                left: 15px;
                top: 50%;
                transform: translateY(-50%);
                background: #fff;
                width: 26px;
                height: 26px;
                border-radius: 2px;
                border: 2px solid #c1c1c1;
                visibility: visible;
                opacity: 1;
                z-index: 1;
                transition: all .4s ease-in-out;
            }

            .checkmark {
                position: absolute;
                left: 15px;
                top: 24px;
                width: 0;
                height: 21px;
                z-index: 2;
                transition: all .8s ease-in-out;
                background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAVCAYAAABVAo5cAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDYuMC1jMDAyIDc5LjE2NDM1MiwgMjAyMC8wMS8zMC0xNTo1MDozOCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIxLjEgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjIwQzFCMjkxNDVERDExRUI5NDgxRjUyMThDODI4REFFIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjIwQzFCMjkyNDVERDExRUI5NDgxRjUyMThDODI4REFFIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MjBDMUIyOEY0NUREMTFFQjk0ODFGNTIxOEM4MjhEQUUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MjBDMUIyOTA0NUREMTFFQjk0ODFGNTIxOEM4MjhEQUUiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6JYfubAAABIklEQVR42mJgoAeYF5oIxDIgJiMdLKsAku1AfBeIHZjpZBkICAGxMiOdLAOBK0DsxEhPyxiSVr9mpKdl1E80BCyjroVEWEY9C4m0DASYqGBZHbGWISycF5oJxK1kWNYBJBuRRC7gswwSpPNCY4D0Yii/B4jLgBr+E2lZOZLIKSB2A+r9iE8byIdZSPwSIJ4GNIyRFpbBLPQE4mNIYhlAPB9oKDO1LUOk0nmhXEByCxA7IsktA+IEoEG/qWUZaraAWLoSiH2Q5DcDcQjQwF/UsAwzH84LZQOSq4DYH0l0BxBfBeJiSi3DnvEhcbcIiKNw6CHbMuwZP2n1XyAZB8RzqW0Z7pIGYmkqEM9AEj1MqWXElaWQxGIGTkxJq79RWhICBBgAA4J6M+ciZckAAAAASUVORK5CYII=');
            }

            .text {
                position: absolute;
                left: 50px;
                top: 50%;
                transform: translateY(-50%);
                font-size: 14px;
            }

            &.solved {
                .checkbox {
                    opacity: 0;
                    visibility: hidden;
                }

                .checkmark {
                    width: 28px;
                }
            }

            &.expired {
                .expired-text {
                    display: block;
                }

                .checkbox {
                    border-color: #ff0000;
                }

                .checkbox-container {
                    top: 17px;
                }
            }

            .logo-container {
                position: absolute;
                top: 7px;
                right: 0;
                text-align: center;
                font-size: 10px;
                line-height: 1em;
                width: 80px;

                img {
                    width: 32px;
                    margin-bottom: 2px;
                }

                a, span {
                    text-decoration: none;
                    font-size: 8px;
                    color: #f5f5f5;
                }
            }

            .challenge {
                visibility: hidden;
                opacity: 0;
                position: absolute;
                left: 52px;
                background: #fff;
                transform: translateY(-50%);
                border: 1px solid #eee;
                box-shadow: rgba(0, 0, 0, 0.2) 2px 2px 3px;
                transition: all .4s ease-in-out;
                z-index: 999;

                &.visible {
                    visibility: visible;
                    opacity: 1;
                }

                .bubble-arrow {
                    position: absolute;
                    border-style: solid;
                    width: 0px;
                    height: 0px;
                    top: 50%;
                    right: 100%;
                    transform: translateY(40px);
                }

                .bubble-arrow-1 {
                    border-width: 11px;
                    border-color: transparent rgb(204, 204, 204) transparent transparent;
                    margin-top: -11px;
                }

                .bubble-arrow-2 {
                    border-width: 10px;
                    border-color: transparent rgb(255, 255, 255) transparent transparent;
                    margin-top: -10px;
                }

                .header {
                    background: #4A90E2;
                    color: #fff;
                    padding: 24px;
                    height: 60px;
                    font-size: 16px;
                    margin: 7px;

                    strong {
                        display: block;
                        font-size: 24px;
                    }
                }

                .squares {
                    margin: 5px;

                    table {
                        border-collapse: collapse;
                    }

                    img {
                        position: relative;
                        width: 378px;
                        height: 378px;
                    }

                    td {
                        padding: 2px;

                        > div {
                            position: relative;

                            div {
                                overflow: hidden;
                                height: 126px;
                                width: 126px;
                                transition: 0.1s ease-in-out;
                            }

                            &.selected {
                                div {
                                    transform: scale(0.8);
                                }

                                &:after {
                                    position: absolute;
                                    top: 0;
                                    top: 0;
                                    display: block;
                                    width: 32px;
                                    height: 32px;
                                    content: "";
                                    background: url('data:image/png;base64,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')
                                }
                            }
                        }
                    }

                    .error-message {
                        display: none;
                        color: #d14836;
                        text-align: center;
                        padding: 7px 0;
                        font-size: 14px;

                        &.visible {
                            display: block;
                        }
                    }
                }

                .footer {
                    position: relative;
                    height: 60px;
                    padding: 7px;
                    border-top: 1px solid #ddd;

                    .icons {
                        span {
                            display: inline-block;
                            padding: 6px 8px 0 8px;
                            cursor: pointer;

                            &:hover img {
                                opacity: 1;
                            }
                        }

                        img {
                            width: 32px;
                            height: 32px;
                            opacity: 60%;
                        }
                    }

                    button {
                        position: absolute;
                        top: 8px;
                        right: 7px;
                        background: #4A90E2;
                        color: #fff;
                        border-radius: 2px;
                        font-size: 14px;
                        height: 42px;
                        line-height: 42px;
                        min-width: 100px;
                        padding: 0 10px;
                        text-align: center;
                        transition: all 0.5s ease;
                        border: none;
                        cursor: pointer;
                    }
                }

                .help {
                    font-size: 12px;
                    font-weight: 400;
                    overflow-y: scroll;
                    padding: 5px 20px 5px 20px;
                    color: #000;
                    line-height: 1.1em;

                    &.visible {
                        display: block;
                    }
                }
            }
        }

        .xlight & #captcha-container {
            border: 1px solid #d3d3d3;
            background: #f9f9f9;

            .logo-container {
                a, span {
                    color: #182026;
                }
            }
        }
    }
</style>